<div
  class="flex flex-row"
  [ngClass]="canClick && !fieldDef.meta?.value_hidden ? 'dotted-underline' : ''"
  (click)="clickField($event)"
>
  <div class="font-semibold mr-1 text-md" *ngIf="!excludeLabels">{{ fieldDef.label }}:</div>
  @if (fieldDef.meta?.value_hidden) {
    <div class="text-md">{{ value }}</div>
  } @else {
    <div class="text-md">
      <div class="tags-div editable">
        <span class="labels" *ngIf="tags && tags.length > 0">
          <span
            class="label"
            *ngFor="let tag of tags | keyvalue"
            [ngClass]="['text-cool-gray-500', 'bg-cool-gray-200']"
          >
            {{ tag.value }}
          </span>
        </span>
      </div>
    </div>
  }
</div>
